<template>
<div>
  <section id="summary" class="container">
    <div class="segment box">
      <h1 class="title is-uppercase has-text-centered">Game Summary</h1>
      <div class="small-box">
        <h2 class="subtitle has-text-centered">Goals</h2>
        <table class="table is-striped">
        <thead>
            <th>Team</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>OT</th>
            <th>PP</th>
            <th>Total</th>
        </thead>
        <tbody>
            <tr>
            <td>{{gameInfo.home_team.name}}</td>
            <td>{{GameSummary.home_goals_p1}}</td>
            <td>{{GameSummary.home_goals_p2}}</td>
            <td>{{GameSummary.home_goals_p3}}</td>
            <td>{{GameSummary.home_goals_ot}}</td>
            <td>{{GameSummary.home_goals_pp}} / {{GameSummary.situation_opts[0].PPTotal}}</td>
            <td><b>{{GameSummary.home_goals_total}}</b></td>
            </tr>
            <tr>
            <td>{{gameInfo.away_team.name}}</td>
            <td>{{GameSummary.away_goals_p1}}</td>
            <td>{{GameSummary.away_goals_p2}}</td>
            <td>{{GameSummary.away_goals_p3}}</td>
            <td>{{GameSummary.away_goals_ot}}</td>
            <td>{{GameSummary.away_goals_pp}} /  {{GameSummary.situation_opts[0].SHTotal}}</td>
            <td><b>{{GameSummary.away_goals_total}}</b></td>
            </tr>
        </tbody>
        </table>
        <h2 class="subtitle has-text-centered"><b>Shots</b></h2>
        <h3 class="subtitle has-text-centered">All Attempts</h3>
        <table class="table is-striped">
        <thead>
            <th>Team</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>OT</th>
            <th>Total</th>
            <th>+/-</th>
        </thead>
        <tbody>
            <tr>
            <td>{{gameInfo.home_team.name}}</td>
            <td>{{GameSummary.home_shots_p1}}</td>
            <td>{{GameSummary.home_shots_p2}}</td>
            <td>{{GameSummary.home_shots_p3}}</td>
            <td>{{GameSummary.home_shots_ot}}</td>
            <td><b>{{GameSummary.home_shots_total}}</b></td>
            <td>{{GameSummary.home_shots_total - GameSummary.away_shots_total}}</td>
            </tr>
            <tr>
            <td>{{gameInfo.away_team.name}}</td>
            <td>{{GameSummary.away_shots_p1}}</td>
            <td>{{GameSummary.away_shots_p2}}</td>
            <td>{{GameSummary.away_shots_p3}}</td>
            <td>{{GameSummary.away_shots_ot}}</td>
            <td><b>{{GameSummary.away_shots_total}}</b></td>
            <td></td>
            </tr>
        </tbody>
        </table>
        <h3 class="subtitle has-text-centered">On Target</h3>
        <table class="table is-striped">
        <thead>
            <th>Team</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>OT</th>
            <th>Total</th>
            <th>+/-</th>
        </thead>
        <tbody>
            <tr>
            <td>{{gameInfo.home_team.name}}</td>
            <td>{{GameSummary.home_sot_p1}}</td>
            <td>{{GameSummary.home_sot_p2}}</td>
            <td>{{GameSummary.home_sot_p3}}</td>
            <td>{{GameSummary.home_sot_ot}}</td>
            <td><b>{{GameSummary.home_sot_total}}</b></td>
            <td>{{GameSummary.home_sot_total - GameSummary.away_sot_total}}</td>
            </tr>
            <tr>
            <td>{{gameInfo.away_team.name}}</td>
            <td>{{GameSummary.away_sot_p1}}</td>
            <td>{{GameSummary.away_sot_p2}}</td>
            <td>{{GameSummary.away_sot_p3}}</td>
            <td>{{GameSummary.away_sot_ot}}</td>
            <td><b>{{GameSummary.away_sot_total}}</b></td>
            <td></td>
            </tr>
        </tbody>
        </table>
        <h2 class="subtitle has-text-centered"><b>Faceoffs</b></h2>
        <table class="table is-striped">
        <thead>
            <th>Team</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>OT</th>
            <th>Total</th>
            <th>+/-</th>
        </thead>
        <tbody>
            <tr>
            <td>{{gameInfo.home_team.name}}</td>
            <td>{{GameSummary.home_fo_p1}}</td>
            <td>{{GameSummary.home_fo_p2}}</td>
            <td>{{GameSummary.home_fo_p3}}</td>
            <td>{{GameSummary.home_fo_ot}}</td>
            <td><b>{{GameSummary.home_fo_total}}</b></td>
            <td>{{GameSummary.home_fo_total - GameSummary.away_fo_total}}</td>
            </tr>
            <tr>
            <td>{{gameInfo.away_team.name}}</td>
            <td>{{GameSummary.away_fo_p1}}</td>
            <td>{{GameSummary.away_fo_p2}}</td>
            <td>{{GameSummary.away_fo_p3}}</td>
            <td>{{GameSummary.away_fo_ot}}</td>
            <td><b>{{GameSummary.away_fo_total}}</b></td>
            <td></td>
            </tr>
        </tbody>
        </table>
      </div>
    </div>
  </section>
</div>
</template>

<script>
export default {
  props: {
    gameId: { type: Number, required: true },
    period: { type: Number, required: true },
    gameInfo: { type: Object, required: true }
  },
  components: {
  },
  data () {
    return {
      GameSummary: []
    }
  },
  computed: {

  },
  watch: {
    endpoint: {
      handler: function (endpoint) {
        this.url = endpoint
      },
      immediate: true
    },
    gameId: {
      handler: function (postData) {
        // console.log('Post data updated: ' + JSON.stringify(this.postData))
        this.fetchGameSummary()
      },
      immediate: true
    }
  },
  methods: {
    gameDataLoaded () {
      console.log('Loaded')
    },
    filterChange () {
    },
    fetchGameSummary () {
      if (this.gameId !== 0) {
        this.$http
          .get(
            'https://devilsapi.roblutken.com/api/app/get/game-summary/' + this.gameId + '/' + 0,
            { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
          )
          .then(
            response => {
              console.log('Game Summary Data is ' + JSON.stringify(response.data))
              this.GameSummary = response.data
            },
            response => {}
          )
      }
    }
  },
  mounted: function () {
    console.log('Game Summary: ' + this.gameId)
    this.fetchGameSummary()
  }
}
</script>
<style lang='scss' scoped>

.segment {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.small-box {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 100%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment h1 {
  color: black;
  text-shadow: 0px 1px 1px #8b0505d1;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment h2 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 2em;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
.stat-title{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}
.stat-category{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.5rem;
  margin: 1rem 0rem;
}
.stat-number{
  font-family: 'Heebo', sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  margin: 1rem 0rem;
  color:black;
}
thead, th {
    background-color: #ffffffd1;
}
.table tr:hover {
    background-color: #8b0505d1;
    color: #fff;
    margin: 0 auto;
}
.table thead td, .table thead th{
  color: rgb(14, 14, 14);
}
.table tbody tr:first-child td, .table tbody tr:first-child:hover{
    background-color: #8b0505d1;
    color: #fff;
    margin: 0 auto;
}
.table tbody tr:last-child{
    background-color: #000000d1;
    color: rgb(255, 255, 255);
    margin: 0 auto;
}
.devils{
  background-color: #000000d1;
  color: rgb(0, 0, 0);
}
/* scrolltable rules */
table  {     width:90%; 
    margin-left:auto; 
    margin-right:auto;  overflow: auto; }
th div { margin-top: -20px; position: absolute; }

/* design */
table { border-collapse: collapse; }
tr:nth-child(even) { background: #EEE; }

@media screen and (min-width: 1292px)
{
  .container{
    min-width: none;
  }
}
</style>



// WEBPACK FOOTER //
// match-summary.vue?181cbfb2